'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationStack = exports.Notification = undefined;

var _notification = require('./notification');

var _notification2 = _interopRequireDefault(_notification);

var _notificationStack = require('./notificationStack');

var _notificationStack2 = _interopRequireDefault(_notificationStack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Notification = _notification2.default;
exports.NotificationStack = _notificationStack2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-notification/dist/index.js
// module id = 1929
// module chunks = 0